var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgPc6Ylk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21606 19.1092C9.21606 14.2348 9.21606 11.7976 10.6601 10.2833C12.1042 8.76904 14.4284 8.76904 19.0769 8.76904C23.7252 8.76904 26.0495 8.76904 27.4936 10.2833C28.9376 11.7976 28.9376 14.2348 28.9376 19.1092C28.9376 23.9835 28.9376 26.4207 27.4936 27.9351C26.0495 29.4493 23.7252 29.4493 19.0769 29.4493C14.4284 29.4493 12.1042 29.4493 10.6601 27.9351C9.21606 26.4207 9.21606 23.9835 9.21606 19.1092Z",
    stroke: "#006D33",
    strokeWidth: 1.19577,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6714 19.1093C23.6714 21.7462 21.6144 23.8837 19.0768 23.8837C16.5393 23.8837 14.4822 21.7462 14.4822 19.1093C14.4822 16.4725 16.5393 14.335 19.0768 14.335C21.6144 14.335 23.6714 16.4725 23.6714 19.1093Z",
    stroke: "#006D33",
    strokeWidth: 1.19577
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7012 13.2737H24.6912",
    stroke: "#006D33",
    strokeWidth: 1.59436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgPc6Ylk);
export default __webpack_public_path__ + "static/media/ig_pc6ylk.ae3e6c9d03c66b02dc1ade46745c05ad.svg";
export { ForwardRef as ReactComponent };